// src/components/settings/ResourcesSettings.js
import React from "react";
import { Link } from "react-router-dom";

const ResourcesSettings = () => {
  return (
    <div className="space-y-6 text-sm">
      <h2 className="text-lg font-semibold">Help & Resources</h2>

      {/* Quick Help */}
      <div>
        <h3 className="text-sm font-medium mb-2">Quick help</h3>
        <ul className="space-y-2 list-disc list-inside text-gray-700">
          <li>
            <strong>Password reset:</strong> Use the sign-in screen “Forgot password” flow (or your Security settings if available).
          </li>
          <li>
            <strong>Account settings:</strong> Update your display name and profile information in Account settings.
          </li>
          <li>
            <strong>How trades work:</strong> NexterZone manages the process end-to-end (no direct buyer–seller contact).
          </li>
        </ul>
      </div>

      {/* Primary Support CTA (NO email exposure) */}
      <div>
        <h3 className="text-base font-medium mb-2">Need help from NexterZone?</h3>
        <p className="text-gray-600 mb-3">
          Use the Support form so the platform can assist securely (and link your request to a trade when relevant).
        </p>

        <Link
          to="/support"
          className="inline-block px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Contact Support
        </Link>

        <div className="mt-2 text-xs text-gray-500">
          For urgent safety issues, use <Link to="/report" className="underline text-blue-600">Report an item</Link> from the listing page.
        </div>
      </div>

      {/* Internal Resources (preferred) */}
      <div>
        <h3 className="text-base font-medium mb-2">Help Center</h3>
        <div className="flex flex-wrap gap-3 text-xs">
          <Link to="/help" className="text-blue-600 underline">Help Center</Link>
          <Link to="/faq" className="text-blue-600 underline">FAQ</Link>
          <Link to="/trust-safety" className="text-blue-600 underline">Trust & Safety</Link>
          <Link to="/help/how-trades-work" className="text-blue-600 underline">How trades work</Link>
        </div>
      </div>

      {/* Legal (internal routes) */}
      <div className="flex items-center gap-4 text-sm">
        <h3 className="text-base font-medium">Legal:</h3>
        <Link to="/terms" className="text-blue-600 underline text-xs">
          Terms of Use
        </Link>
        <Link to="/privacy" className="text-blue-600 underline text-xs">
          Privacy Policy
        </Link>
      </div>
    </div>
  );
};

export default ResourcesSettings;
